import { createSRPCClient } from "@srpc/core/client";
import type { AppRouter } from "~/srpc/routes/app.router";

export const rpc = createSRPCClient<AppRouter>({
	endpoint: "/api/srpc",
});
